<template>
    <UApp :locale="uiLocale">
        <component :is="layout">
            <router-view />
        </component>
    </UApp>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { useI18n } from 'vue-i18n'
    import * as locales from '@nuxt/ui/locale'

    import Blank from '@/layouts/Blank.vue'
    import Default from '@/layouts/Default.vue'

    const route = useRoute()
    const { locale } = useI18n()

    const uiLocale = computed(() => (locales as unknown as Record<string, typeof locales.en>)[locale.value] ?? locales.en)

    const layouts = { Default, Blank }
    const layout = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Default'])
</script>
